import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import MediaViewer from './MediaViewer'
import './camera.scss'

// Popup xem ảnh full màn hình: Trước/Sau, vuốt (MediaViewer), phím ← → và Esc (PC).
// images: [{ url }]; index < 0 thì không hiện.
const ImagePreviewModal = ({ images, index, onIndexChange, onClose }) => {
    const count = images.length
    const open = index >= 0 && !!images[index]

    useEffect(() => {
        if (!open) return undefined
        const onKey = (e) => {
            if (e.key === 'Escape') onClose()
            else if (e.key === 'ArrowLeft' && count > 1) onIndexChange((index - 1 + count) % count)
            else if (e.key === 'ArrowRight' && count > 1) onIndexChange((index + 1) % count)
        }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [open, index, count, onIndexChange, onClose])

    if (!open) return null

    return (
        <MediaViewer
            items={images.map(image => ({ url: image.url, video: false }))}
            index={index}
            onIndexChange={onIndexChange}
            onClose={onClose}
        />
    )
}

ImagePreviewModal.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string,
    })).isRequired,
    index: PropTypes.number.isRequired,
    onIndexChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default ImagePreviewModal
